import React from "react";
import Navbar from "../../assets/Navbar/Navbar";
import Footer from "../../assets/Footer/Footer";
import '../Work.css';
import { useNavigate } from "react-router-dom";
// import gif1 from "../../assets/Images/bag.GIF";
import prog1 from "../../assets/Images/progress/3d1.png";
import prog2 from "../../assets/Images/progress/3d.png";
import prog3 from "../../assets/Images/progress/3d.mp4";






import Slideshow from "../../assets/Slideshow/Slideshow"; 


const Work3D = () => {
    const navigate = useNavigate();
    const images = [prog1,prog2,prog3];
    

    return (
        <div className="page-container">
            <Navbar />
            <div className="content-work-headings">
                <h1>Homepage 3D tracking cursor</h1>
                <p>Still in progress</p>

                
            </div>

            <div className="line"></div>

            <div className="content-work">
                <div className="content-work-3d">
                    <div className="content-work-3d-text">
                        <h2>Why I want to do this 3D?</h2>
                        <p>
                            I was given a feedback by amer that I could make my portfolio website more attractive and interactive by using a 3D model on my homepage
                            to follow the user's cursor when they are moving the mouse.
                        </p>

                        <h2>Feedback I've gotten to help me make this</h2>
                        <p>
                            While doing this I also asked for feedback from Josh and Jan, Josh helped me making
                            the 3D model simpler in size so that if I use this 3D model it wouldn't get too laggy, while Jan help me see a perspective to make this 3D model
                            in a way it wouldn't be too Uncanny Valley.
                        </p>
                        
                    </div>

                    <div className="content-work-3d-slideshow">
                        <Slideshow images={images} />

                    </div>

                    
                </div>
            </div>

            <Footer />
            </div>
    );
};

export default Work3D;